export default "__VITE_ASSET__C9zDlLo3__"